/*
 * @Author: your name
 * 
 */
import { ComponentProps } from 'react';
import { Route, withRouter, RouteComponentProps } from 'react-router-dom';

import { fomatParentPath } from '../../utils';
import { InviteJoin } from '../../lib';

function RouteInviteJoin(props: RouteComponentProps & ComponentProps<any>) {
    const parentPath: string = fomatParentPath(props);
    return (
        <>
            <Route weId={`${props.weId || ''}_6p6nql`} exact path={`${parentPath}/passport/invite`} component={InviteJoin} />
            <Route weId={`${props.weId || ''}_6p6nql`} exact path={`${parentPath}/passport/join`} component={InviteJoin} />
        </>
    )
}



export default withRouter(RouteInviteJoin);
